@let logged = $logged();
@let willImpersonate = emailControl.valid;

<h1 mat-dialog-title>{{ logged ? translate('common.auth.adminRequired') : translate('common.auth.required') }}</h1>

<div mat-dialog-content>
  @if (logged) {
    <p>{{ translate('common.auth.insufficientPermissions') }}</p>
    <p>{{ translate('common.auth.elevate') }}</p>
  } @else {
    <p>{{ translate('common.auth.authenticationNeeded') }}</p>
    <p>{{ translate('common.auth.authenticateBelow') }}</p>
  }

  @if ($superuser()) {
    <div class="ui-row my-4">
      <mat-form-field class="flex-1">
        <mat-label>{{ translate('common.auth.userEmail') }}</mat-label>
        <input
          type="email"
          matInput
          inputmode="email"
          [placeholder]="translate('common.auth.emailAddress')"
          (keyup.enter)="impersonate()"
          [formControl]="emailControl" />
        <mat-hint>{{ translate('common.auth.superuserImpersonate') }}</mat-hint>
      </mat-form-field>
    </div>
  }
</div>

<div mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ translate('common.actions.cancel') }}</button>
  <button
    mat-flat-button
    (click)="willImpersonate ? impersonate() : login()"
    [disabled]="willImpersonate ? !emailControl.valid : false">
    {{
      willImpersonate
        ? translate('common.auth.impersonateUser')
        : logged
          ? translate('common.auth.authenticateAdmin')
          : translate('common.auth.authenticateGoogle')
    }}
  </button>
</div>
